/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable import/no-extraneous-dependencies */
import { Injectable } from '@angular/core';

import { getFormattedUTCDate } from '@arc/unified-payments-frontend/date-utils';
import {
  DiscountApplicationKind,
  GetSessionSummaryResponse,
  PaymentExclusionOverrideSetting,
  PaymentPreviewPayableV1Response,
  PaymentPreviewPaymentV1Request,
  PaymentPreviewV1Request,
  SelectedPaymentAccount,
  SessionDocumentInfo,
} from '../models';

@Injectable({ providedIn: 'root' })
// eslint-disable-next-line class-methods-use-this
export class PaymentPreviewHelperService {
  static buildPaymentPreviewRequest(
    referenceNumber: string,
    sessionSummary: GetSessionSummaryResponse,
    totalAmount: number,
    totalSurcharge: number,
    selectedDocuments: SessionDocumentInfo[],
    currencyCode: string,
    paymentDate: Date,
    paymentAccount: SelectedPaymentAccount,
    paymentAllowOverrideCC: PaymentExclusionOverrideSetting,
    allowStatementPayments: boolean,
    paymentServiceProvider: string = null,
  ): PaymentPreviewV1Request {
    const paymentPreviewPaymentV1Request: PaymentPreviewPaymentV1Request = {
      payables: selectedDocuments
        .map((selectedDocument) => {
          const previewDocument: PaymentPreviewPayableV1Response = {
            burn: selectedDocument.urn,
            amount: selectedDocument.payableAmount,
            discountOverrideFlag: selectedDocument.overrideDiscount
              ? DiscountApplicationKind.ManualExclusion
              : null,
          } as unknown as PaymentPreviewPayableV1Response;

          if (selectedDocument.surchargeAmount != null) {
            previewDocument.surcharge = selectedDocument.surchargeAmount;
          }

          if (selectedDocument.description != null) {
            previewDocument.description = selectedDocument.description;
          }

          if (
            !allowStatementPayments &&
            selectedDocument.documentType === 'statement'
          ) {
            return null;
          }

          return previewDocument;
        })
        .filter((document) => document !== null),
      currency: currencyCode,
      totalAmount,
      totalSurcharge,
    };

    const paymentPreviewV1Request: PaymentPreviewV1Request = {
      payment: paymentPreviewPaymentV1Request,
      overrideCardRestrictions: paymentAllowOverrideCC.allowRestrictionOverride,
      paymentSchedule: {
        allowDateToBeMoved: true,
        paymentDate: getFormattedUTCDate(paymentDate),
      },
      paymentInitiator: {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        paymentSourceType:
          (sessionSummary as any).paymentSourceType ??
          sessionSummary.sessionType,
        paymentSource: sessionSummary.originatingApplication,
        embeddedPaymentInitiationSource:
          sessionSummary.embeddedPaymentInitiationSource,
      },
      externalUser: {
        burn: sessionSummary.externalUserUrn
          ? sessionSummary.externalUserUrn
          : null,
      },
      paymentReference: {
        burn: referenceNumber ? referenceNumber.toString() : null,
      },
      paymentServiceProvider: paymentServiceProvider,
    };

    if (paymentAccount) {
      (paymentPreviewV1Request as any).paymentAccount = {
        burn: paymentAccount.burn,
      };
    }

    return paymentPreviewV1Request;
  }
}
